export var AuthProviderEnum;
(function (AuthProviderEnum) {
    AuthProviderEnum["GOOGLE"] = "google";
    AuthProviderEnum["GITHUB"] = "github";
})(AuthProviderEnum || (AuthProviderEnum = {}));
export var UserRoleEnum;
(function (UserRoleEnum) {
    UserRoleEnum["USER"] = "user";
})(UserRoleEnum || (UserRoleEnum = {}));
